import { keymap } from 'prosemirror-keymap';

import {
	splitListItem,
	sinkListItem,
	liftListItem,
	toggleOrderedList,
	toggleUnorderedList,
	backspaceIntoList,
} from '../commands';

const listKeymap = keymap({
	Enter: splitListItem,
	Tab: sinkListItem,
	'Shift-Tab': liftListItem,
	'Mod-Shift-7': toggleOrderedList,
	'Mod-Shift-8': toggleUnorderedList,
	Backspace: backspaceIntoList,
});

export default listKeymap;
